import { Club, Student, User } from "@/types";

export function getSurveyUrl(user: User, student: Student, club: Club) {
  return "https://forms.playincluded.com/s/BrickClubRegistration/?uId=" + user.id + "&mId=" + student.id + "&bcId=" + club.id + "&fId=" + club.facilitator_id;
}
